import { api } from 'api';
import { PaginatedResponse, PaginationParams } from 'common/state/types';
import { confirmInDangerousDev } from 'common/utils/dev';
import { requestErrorAction } from 'common/utils/requestErrorHandling';
import { AccountTransfer, AccountTransferStatuses } from './actions';

// #region AccountTransfer
export interface AccountTransfersParams extends PaginationParams {
  status?: AccountTransferStatuses;
  start_date?: string;
  end_date?: string;
}

export const requestAccountTransfers = async (
  params?: AccountTransfersParams
) =>
  await api.get<PaginatedResponse<AccountTransfer>>('/account_transfer/', {
    params,
  });

export const doGetAccountTransfers =
  (params?: AccountTransfersParams) => async (dispatch) => {
    dispatch({ type: 'accounts/transfers/started' });

    try {
      const response = await requestAccountTransfers(params);

      dispatch({
        type: 'accounts/transfers/finished',
        transfers: response.data.results,
        count: response.data.count,
        next: response.data.next,
        previous: response.data.previous,
      });
    } catch (e) {
      dispatch(
        requestErrorAction(
          { type: 'accounts/transfers/finished' },
          e,
          'Failed to get account transfers.'
        )
      );
    }
  };

export interface NewAccountTransferBodyData {
  account: string;
  amount: string;
  currency: string;
  status: string;
  wallet: string;
}

export const requestNewAccountTransfer = async (
  data: NewAccountTransferBodyData
) =>
  confirmInDangerousDev(
    async () => await api.post<AccountTransfer>('/transfer/', data)
  );

export const doNewAccountTransfer =
  (data: NewAccountTransferBodyData) => async (dispatch) => {
    dispatch({ type: 'accounts/transfers/new/started' });

    try {
      await requestNewAccountTransfer(data);

      dispatch({
        type: 'accounts/transfers/new/finished',
        success: true,
      });
    } catch (e) {
      dispatch(
        requestErrorAction(
          { type: 'accounts/transfers/new/finished' },
          e,
          'Failed to mnake new account transfer.'
        )
      );
    }
  };

export const requestAcceptAccountTransfer = async (url: string) =>
  confirmInDangerousDev(
    async () =>
      await api.patch<AccountTransfer>(url, {
        status: AccountTransferStatuses.TRANSFERED,
      })
  );

export const doAcceptAccountTransfer = (url: string) => async (dispatch) => {
  dispatch({ type: 'accounts/transfers/accept/started' });

  try {
    await requestAcceptAccountTransfer(url);

    dispatch({
      type: 'accounts/transfers/accept/finished',
      success: true,
    });
  } catch (e) {
    dispatch(
      requestErrorAction(
        { type: 'accounts/transfers/accept/finished' },
        e,
        'Failed to accept account transfer.'
      )
    );
  }
};

export const requestDeclineAccountTransfer = async (url: string) =>
  confirmInDangerousDev(
    async () =>
      await api.patch<AccountTransfer>(url, {
        status: AccountTransferStatuses.CANCELLED,
      })
  );

export const doDeclineAccountTransfer = (url: string) => async (dispatch) => {
  dispatch({ type: 'accounts/transfers/decline/started' });

  try {
    await requestDeclineAccountTransfer(url);

    dispatch({
      type: 'accounts/transfers/decline/finished',
      success: true,
    });
  } catch (e) {
    dispatch(
      requestErrorAction(
        { type: 'accounts/transfers/decline/finished' },
        e,
        'Failed to decline account transfer.'
      )
    );
  }
};
// #endregion
